<template>
  <div>
    <form action="/">
      <van-search
        v-model="value"
        type="number"
        show-action
        placeholder="请输入手机号"
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
    <div class="tips">注：需购买易元剪辑年卡会员才有资格升级为代理商</div>

    <van-row style="margin-top: 10px; padding: 10px 16px">
      <van-col span="6" class="title">团员手机号</van-col>
      <van-col span="6" class="title">充值金额</van-col>
      <van-col span="6" class="title">充值时间</van-col>
      <van-col span="6" class="title">升级代理商</van-col>
    </van-row>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="item in list" :key="item.phone">
          <van-row>
            <van-col span="6" class="phone">{{ item.phone }}</van-col>
            <van-col span="6" class="phone">{{ item.payNum}}</van-col>
            <van-col span="6" class="phone">{{ item.payTime }}</van-col>
            <van-col span="6" class="btn" @click="showDialog(item)"
              >升级</van-col
            >
          </van-row>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      value: "",
      list: [],
      loading: false,
      finished: false,
      refreshing: false,

      pageNum: 1,
      pageSize: 5,
    };
  },

  methods: {
    onSearch(val) {
      this.refreshing = true;
      this.onRefresh();
    },
    onCancel() {
      this.refreshing = true;
      this.onRefresh();
    },

    showDialog(item) {
      Dialog.confirm({
        message: `要将${item.phone}升级为代理商吗？`,
      })
        .then(() => {
          // on confirm
          this.up2Agent(item)
        })
        .catch(() => {
          // on cancel
        });
    },

    up2Agent(item) {
      this.$request.POST({
        url: `/agent/vip/up/agent?phone=${item.phone}`,
        success: (obj) => {
          this.refreshing = true;
          this.onRefresh();
          this.showDialogOk();
        },
      });
    },

    showDialogOk() {
      Dialog({ message: "升级代理商成功" });
    },

    onLoad() {
      this.pageNum++;
      this.getList();
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 1;
      this.getList();
    },

    getList() {
      this.$request.GET({
        url: "agent/new/year/vip/list",
        params: {
          phone: this.value,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
        success: (obj) => {
          this.loading = false;
          if (!obj.hasNextPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          if (this.refreshing || this.pageNum == 1) {
            this.list = obj.list;
            this.refreshing = false;
          } else {
            this.list = this.list.concat(obj.list);
          }
        },
      });
    },
  },

  mounted() {
    this.refreshing = true;
    this.onRefresh();
  },
};
</script>

<style lang="less" scoped>
.tips {
  margin-left: 20px;
  text-align: left;
  font-size: 10px;
  color: red;
}
.title {
  font-size: 15px;
  font-weight: 600;
  color: black;
}
.phone {
  font-size: 14px;
  color: black;
  text-align: center;
}
.btn {
  text-align: center;
  color: #36a732;
  text-decoration: underline;
  font-size: 12px;
}
</style>

